// extracted by mini-css-extract-plugin
export default {"products":"At-z","card":"Bt-z","oosMessaging":"Ct-z"};